const defaults = {
  r: 100,
  start: 30,
  end: 150,
};
export default function Layout(options) {
  Object.assign(this, defaults, options);

  if (!this.rx) {
    this.rx = this.r;
  }
  if (!this.ry) {
    this.ry = this.r;
  }
}

Layout.prototype.run = function () {
  this.cy.layoutOptions = this.options;
  this.cy.$('.node').layoutPositions(this, this, n => {
    const children = n.children();
    const { x, y } = n.position();

    // setTimeout(() => {
    //   children.forEach((ch, i) => {
    //     const el = ch.data("element");
    //     ch.position({
    //       x: x,
    //       y: y + (i * (el.height() + 25)) ,
    //     });
    //   });
    // })
    return { x, y };
  });

  return this;
};
